import styled from '@emotion/styled';
import { Avatar } from 'components';

type DrawerCellProps = {
  text: string;
  rowId: string;
  onOpen?: (rowId: string) => void;
  color?: string;
  avatarText?: string;
};

export const DrawerCell = ({ text, rowId, onOpen, color, avatarText }: DrawerCellProps) => {
  const handleOpen = () => {
    onOpen?.(rowId);
  };

  return (
    <StyledTableCell onClick={handleOpen}>
      {avatarText && (
        <Avatar
          size="xs"
          letters={avatarText}
          color={color ? (color.startsWith('#') ? color : `#${color}`) : ''}
        />
      )}
      <span role="cell">{text}</span>
    </StyledTableCell>
  );
};

const StyledTableCell = styled.div`
  height: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  :hover {
    cursor: pointer;
    span {
      text-decoration: underline;
    }
  }
  & > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;
